<ap-findcontrol
  [baseId]="Id + 'fndControl'"
  [findControlId]="findcontrolType"
  [selectedPks]="list"
  [placeHolder]=""
  [disabled]="isDisable"
  [singleSelect]="isSingleSelect"
  [apFormGroup]="formGroup"
  [controlName]="controlName"
  [messageOverrides]="messageOverrides"
  (selectedPksChange)="onChange($event)"
>
</ap-findcontrol>
